<template>
  <!-- star -->

  <div class="youjiaopage_wrap">
    <navBar></navBar>
    <banner2 :bannerH="h1" :bannerP="p1" :bannerImg="phoneInfo.image_input"></banner2>
    <!-- 面包屑 -->
    <div class="Crumbs">
      <div>当前位置：首页><span>联系我们</span></div>
    </div>
    <!-- 上部分 -->
    <div class="talk_top">
      <div class="talk_top_cont">
        <div class="talk_top_cont_l">
          <h1>联系我们</h1>
          <p>contact us</p>
        </div>
        <div class="talk_bottom" v-html="phoneInfo.content">
        </div>
      </div>
    </div>
    <footer2></footer2>

    <!-- end -->
  </div>
</template>

<script>
import footer2 from "../components/footer.vue";
import banner2 from "../components/banner.vue";
export default {
  name: "keji",
  components: {
    footer2,
    banner2,
  },
  data() {
    return {
      h1: "联系我们",
      Img1: require("../assets/img/banner2.png"),

      p1: "城际物流，领跑中国物流行业",
      phoneInfo:''
    };
  },
  created() {
    this.contactInfo();
  },
  methods: {
    contactInfo(){
      let that = this;
      this.reqApi.getContactInfo(null,(res)=>{
        console.log('联系我们：',res)
        that.phoneInfo = res;
      },(err)=>{
        //业务错误返回
        console.log(err)
      })
    }
  }
};
</script>
<style scoped>
@charset "utf-8";

.youjiaopage_wrap {
  width: 100vw;
  margin: 0 auto;
  height: 1000px;
}
/* 面包屑 */
.Crumbs {
  height: 46px;
  margin: 0 120px;
}
.Crumbs {
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
  line-height: 17px;
}
.Crumbs div {
  line-height: 46px;
}
.Crumbs span {
  color: #000000;
}
/* 联系我们 */
.talk_top{
  margin: 0 120px;
}
.talk_top_cont {
  display: flex;
  padding: 50px 0px 10px 0px;
}

.talk_top_cont_l {
  width: 40%;
  height: 134px;
}
.talk_top_cont_l > h1 {
  font-size: 32px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #23337f;
  line-height: 45px;
}
.talk_top_cont_l p {
  width: 235px;
  height: 80px;
  font-size: 48px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #f6f6f6;
  line-height: 40px;
}
.talk_top_cont_c {
  display: flex;
  width: 487px;
}
.talk_top_cont_c {
  font-size: 18px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #444444;
  line-height: 25px;
}

.talk_top_cont_c_t_l {
  margin-right: 60px;
}
.talk_top_cont_r {
  width: 117px;
}
.talk_top_cont_r img {
  border: dashed;
}
.talk_top_cont_c_t_r {
  margin-top: 36px;
}
.talk_top_cont_c_b_r {
  margin-top: 36px;
}
</style>
